const CHUNK_LOAD_PATTERNS = [
  'failed to fetch dynamically imported module',
  'error loading dynamically imported module',
  'importing a module script failed',
  'unable to preload css',
  'loading chunk',
  'chunkloaderror',
  'dynamically imported module'
]

export function isChunkLoadError(error: unknown): boolean {
  if (!error) return false
  const message =
    error instanceof Error ? error.message : typeof error === 'string' ? error : undefined
  if (!message) return false
  const normalized = message.toLowerCase()
  return CHUNK_LOAD_PATTERNS.some(pattern => normalized.includes(pattern))
}
